import Marquee from "react-fast-marquee";
import { Wrench } from "lucide-react";
import { useSettings } from "../settings";

export const ServicesMarquee = () => {
  const { settings } = useSettings();
  const items = (settings.marquee_items || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  if (items.length === 0) return null;

  return (
    <section data-testid="services-marquee" className="overflow-hidden border-y border-white/10 bg-black py-6">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="mx-6 flex items-center gap-12">
            <span className="font-heading text-lg font-bold uppercase tracking-[0.3em] text-white/40">
              {item}
            </span>
            <Wrench className="h-4 w-4 text-volt" strokeWidth={1.5} />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
